export const DEFAULT_DOCUMENT_TITLE = 'EUREKERS';

export function documentTitleForRoute(route = {}) {
  if (route.meta && route.meta.documentTitle) return route.meta.documentTitle;

  const matched = Array.isArray(route.matched) ? [...route.matched].reverse() : [];
  const record = matched.find(item => item.meta && item.meta.documentTitle);
  return record ? record.meta.documentTitle : DEFAULT_DOCUMENT_TITLE;
}

export function updateDocumentTitle(route, target = document) {
  if (!target) return;
  target.title = documentTitleForRoute(route);
}
